import React, {Component} from 'react';
import {makeRequest} from "../../../../helpers/network_utils";
import {PATCH_REQUEST, POST_REQUEST} from "../../../../values/globals";
import endpoints from "../../../../routes/endpoints";
import Swal from "sweetalert2";
import {handleChange} from "../../../../helpers/helper_functions";

const $ = window.$;

class ZoomLinkAdd extends Component {

    state = {
        link: '',
        loading: false,
        errors: {}
    }

    componentDidMount() {
        const {zoom_link} = this.props;
        if (zoom_link?.id)
            this.setState({
                link: zoom_link.link
            });
    }

    handleSubmit = () => {
        this.setState({
            loading: true
        })
        const {zoom_link} = this.props;
        const {link} = this.state;
        const method = zoom_link?.id ? PATCH_REQUEST : POST_REQUEST;
        const endpoint = zoom_link?.id ? `${endpoints.zoom_links}${zoom_link.id}/` : endpoints.zoom_links;
        makeRequest(method, endpoint, {link: link}, () => {
            Swal.fire(
                'Success!',
                `Zoom link was ${zoom_link ? "Edited" : "Saved"} successfully!`,
                'success'
            ).then(() => {
                this.props.getZoomLinks();
                $("#addZoomLinkModal").modal('toggle');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
            });
        }, (error) => {
            this.setState({
                errors: error.response.data
            })
        }, () => {
            this.setState({loading: false})
        }).then()
    }

    render() {
        const {errors, loading,link} = this.state;
        return (
            <div className="modal fade" id="addZoomLinkModal" role="dialog"
                 aria-labelledby="exampleModalCenterTitle"
                 aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalCenterTitle">Add Zoom link</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="col-12">
                                <form>
                                    <div className="form-group">
                                        <label htmlFor="exampleInputPassword1">Zoom link</label>
                                        <input value={link || ""} onChange={(e) => handleChange(e, this)} type="text"
                                               className="form-control" name="link"/>
                                        {errors.link && <p className="small text-danger">{errors.link[0]}</p>}
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button onClick={this.handleSubmit} type="button" className="btn btn-primary"
                                    disabled={loading}>{loading ? "Loading..." : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default ZoomLinkAdd;